export default __webpack_public_path__ + "static/img/noicon.536430d.png";